import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    html {
        scroll-behavior: smooth;
    }

    body,
    html,
    a {
        font-family: 'Inter', sans-serif;
    }

    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
        -webkit-tap-highlight-color: transparent;
    }

    a:hover {
        color: #EB8A3E;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;
        font-size: 16px; /* Prevents iOS zoom on focus */

        :focus-within {
            background: none;
            box-shadow: #008B8B 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Outfit', sans-serif;
        color: #008B8B;
        font-size: clamp(1.75rem, 5vw, 3.5rem);
        line-height: 1.18;
    }

    p {
        color: #333333;
        font-size: clamp(1rem, 2.5vw, 1.3rem);
        line-height: 1.5;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #365660;

        :hover {
            color: #EB8A3E;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
